import * as React from "react";
import { styled, alpha } from "@mui/material/styles";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import axios from "axios";
import { TestLanguage } from "../hooks/testLanguage";
import { OutlinedInput } from "@mui/material";
import { IoIosArrowDropdownCircle } from "react-icons/io";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: "rgb(55, 65, 81)",
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
    ...theme.applyStyles("dark", {
      color: theme.palette.grey[300],
    }),
  },
}));

export default function Option({ name, url, onSelect, setOffertype, offertype, setRegion, region }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [unitStatus, setUnitStatus] = React.useState(null);
  const [itemselected, setItemselected] = React.useState(null);
  let itemsToRender;
  if (name === "Type" || name==="النوع") {
    itemsToRender = offertype
  } else if (name === "Region"|| name === "المنطقة") {
    itemsToRender = region
  } else {
    itemsToRender = unitStatus
  }

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    axios
      .get(`${process.env.REACT_APP_API_URL}${url}`)
      .then(function (response) {
        const names = response?.data?.data;
        console.log("hi", response?.data?.data);

        setUnitStatus(response?.data?.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const handleSelect = async (item) => {
    console.log("item", item);
    console.log("reg", item.regions);
    console.log("offertype", item?.offertypes);
    console.log("offertype2", offertype);
    if (item?.offertypes && setOffertype) {
      setOffertype(item.offertypes);
    }
    if (item?.regions && setRegion) {
      setRegion(item?.regions);
      console.log("region", region);

    }
    setItemselected(item);
    console.log("item.offertypes", item.offertypes);

    setAnchorEl(null);
    if (onSelect) {
      onSelect(name, item); // Sending name and item to parent
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <OutlinedInput
        id="demo-customized-button"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        disableElevation
        sx={{
          borderRadius: "35px",
          backgroundColor: "#f3efee",
          fontWeight: "bolder",
          fontSize: "10px",
          color: "#000",
          cursor: "pointer",
          '.MuiOutlinedInput-notchedOutline': {
            border: 'none',
            boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px'

          },
          // border:'solid red'
        }}
        value={
          itemselected ? ` ${TestLanguage(itemselected, "name")}` : `${name}`
        }
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        style={{
          borderRadius: "50px",
          backgroundColor: "#f5f5f5",
          fontFamily: "Oswald,Cairo, sans-serif",
          fontWeight: "300",
          height: "40px",
          width: "100%",
          fontSize: "15px",
          color: "#000", border: 'none'
        }}
      >
        {TestLanguage(name, "name")}


      </OutlinedInput>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {itemsToRender?.map((i) => (
          <MenuItem onClick={() => handleSelect(i)} disableRipple>
            {TestLanguage(i, "name")}
          </MenuItem>
        ))}
      </StyledMenu>
    </>
  );
}
